import { InvestmentsColumns } from "../../../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/InvestmentsColumns";
import { InvestmentsColConfig } from "../../PortfolioDashboard/Components/Investment/Resource/Contents";

export class InvestmentsColConfigHelper {
    public static getTitle(col: InvestmentsColumns, onEditTreasure: () => void): string {
        const _col = InvestmentsColConfig(onEditTreasure).find((ele) => ele.tableFilter == col);
        return _col ? (_col.title as string) : "";
    }
}
